import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-text",
  "use": "icon-text-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-text\">\r\n    <title>text</title>\r\n    \r\n        <polygon points=\"3.49999999 2.47222222 3.49999999 6.43888889 10.0384615 6.43888889 10.0384615 22.3055556 13.9615385 22.3055556 13.9615385 6.43888889 20.5 6.43888889 20.5 2.47222222\" />\r\n   \r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol